/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagLeftIcon20Regular = forwardRef('ArrowDim1DiagLeftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9 2.25a.75.75 0 0 1 0 1.5H4.81l11.44 11.44V11a.75.75 0 0 1 1.5 0v5A1.75 1.75 0 0 1 16 17.75h-5a.75.75 0 0 1 0-1.5h4.19L3.75 4.81V9a.75.75 0 0 1-1.5 0V4c0-.966.784-1.75 1.75-1.75h5Z" })));
});
